import { apiClient } from './client';
import { ThemeId, ThemeState } from '../data/learning';

export interface AuthUser { id: string; name: string; avatar: string | null; }
export interface Provider { id: string; label: string; }

const apiOrigin = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api').replace(/\/api\/?$/, '');

export const authApi = {
  async me(): Promise<AuthUser | null> {
    try { const { data } = await apiClient.get('/auth/me'); return data.user; } catch { return null; }
  },
  async providers(): Promise<Provider[]> {
    try { const { data } = await apiClient.get('/auth/providers'); return data.providers || []; } catch { return []; }
  },
  // Volledige paginanavigatie naar de backend-OAuth-route.
  loginUrl(provider: string): string { return `${apiOrigin}/api/auth/${provider}`; },
  async logout(): Promise<void> { try { await apiClient.post('/auth/logout'); } catch { /* negeer */ } },
  async getProgress(): Promise<Partial<Record<ThemeId, ThemeState>>> {
    try { const { data } = await apiClient.get('/me/progress'); return data || {}; } catch { return {}; }
  },
  async putProgress(themeId: ThemeId, st: ThemeState): Promise<void> {
    try { await apiClient.put(`/me/progress/${themeId}`, st); } catch { /* negeer */ }
  },
};
